<template>
  <div class="ba-modal"
       @click="setToggleModal ? emitToggleModal('close') : ''"
  >
    <div
      class="ba-modal-content ba-flex ba-f-column ba-gp-3 ba-ai-end"
      @mouseleave="setToggleModal = true" @mouseover="setToggleModal = false"
    >
      <div class="ba-modal--header">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M8.49375 12.75H9.61875V8.25H8.49375V12.75ZM8.99966 6.8625C9.17489 6.8625 9.32188 6.805 9.44063 6.69C9.55938 6.575 9.61875 6.4325 9.61875 6.2625C9.61875 6.08188 9.55949 5.93047 9.44096 5.80828C9.32243 5.68609 9.17555 5.625 9.00034 5.625C8.82511 5.625 8.67813 5.68609 8.55938 5.80828C8.44063 5.93047 8.38125 6.08188 8.38125 6.2625C8.38125 6.4325 8.44051 6.575 8.55904 6.69C8.67758 6.805 8.82445 6.8625 8.99966 6.8625ZM9.00499 16.5C7.97081 16.5 6.99894 16.3031 6.08936 15.9094C5.17979 15.5156 4.38438 14.9781 3.70312 14.2969C3.02188 13.6156 2.48438 12.8197 2.09063 11.9092C1.69688 10.9987 1.5 10.0259 1.5 8.99063C1.5 7.95539 1.69688 6.98252 2.09063 6.07202C2.48438 5.16151 3.02188 4.36875 3.70312 3.69375C4.38438 3.01875 5.18026 2.48438 6.09077 2.09063C7.00127 1.69688 7.97414 1.5 9.00938 1.5C10.0446 1.5 11.0175 1.69688 11.928 2.09063C12.8385 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.96084 16.5 8.99501C16.5 10.0292 16.3031 11.0011 15.9094 11.9106C15.5156 12.8202 14.9813 13.6145 14.3063 14.2934C13.6313 14.9724 12.8375 15.5099 11.925 15.9059C11.0125 16.302 10.0392 16.5 9.00499 16.5Z" fill="#0072E1"/>
        </svg>
        <div class="header ba-montserrat-600">Select the tools to enable access</div>
        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none"
             @click="emitToggleModal('close')"
        >
          <g clip-path="url(#clip0_286_8035)" filter="url(#filter0_d_286_8035)">
            <path d="M25.25 14.8075L24.1925 13.75L20 17.9425L15.8075 13.75L14.75 14.8075L18.9425 19L14.75 23.1925L15.8075 24.25L20 20.0575L24.1925 24.25L25.25 23.1925L21.0575 19L25.25 14.8075Z" fill="#0072E1"/>
          </g>
          <defs>
            <filter id="filter0_d_286_8035" x="-3" y="-3" width="48" height="48" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="1" dy="2"/>
              <feGaussianBlur stdDeviation="7.5"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_286_8035"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_286_8035" result="shape"/>
            </filter>
            <clipPath id="clip0_286_8035">
              <rect width="18" height="18" fill="white" transform="translate(11 10)"/>
            </clipPath>
          </defs>
        </svg>
      </div>

      <div class="ba-modal--content">
        <div class="check-card">
          <div class="input-select">
            <span class="ba-color-dark6 ba-montserrat-400">Select All</span>
            <input type="checkbox" :checked="selectAll" @click="selectAllTools">
          </div>
        </div>

        <div v-for="(group, i) in toolList" :key="i" class="tools-group">
          <div class="check-title ba-bg-light14 ba-flex ba-ai-center">
            <span class="ba-montserrat-500 ba-color-dark5">{{ group.tool.title }}</span>
          </div>

          <div class="check-card">
            <div v-for="(tool, a) in group.children"
                 :key="a"
                 class="input-select"
            >
              <span class="ba-color-dark6 ba-montserrat-400" v-html="tool.tool.title"/>
              <input type="checkbox" v-model="tool.selected">
            </div>
          </div>
        </div>
      </div>


      <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe ba-gp-1">
        <button class='ba-btn ba-md ba-light' @click="emitToggleModal('close')">
          {{ translation.label_cancel }}
        </button>

        <button class='ba-btn ba-md ba-blue' @click="emitToggleModal('save')">
          {{ translation.save }}
        </button>
      </div>

    </div>
  </div>

</template>
<script>
export default {
  name: "tools-modal",
  props: ["toolList", "translation", "toolsSelected", "closeModal"],
  data() {
    return {
      setToggleModal: true,
      selectAll: false
    }
  },
  mounted() {
    this.verifySelectedTools()
  },
  methods: {
    emitToggleModal(action) {
      this.closeModal(action)
    },
    selectAllTools() {
      let status = !this.selectAll

      this.toolList.forEach(x => {
        x.selected = status
        if (x.children.length > 0) {
          x.children.forEach(y => {
            y.selected = status
          })
        }
      })

      this.selectAll = !this.selectAll
    },
    verifySelectedTools() {
      let checked = true

      this.toolList.forEach(x => {
        if (!x.selected) {
          checked = false
        } else {
          if (x.children.length > 0) {
            x.children.forEach(y => {
              if (!y.selected) {
                checked = false
              }
            })
          }
        }
      })

      this.selectAll = checked
    }
  }
}
</script>

<style scoped lang="scss">
.ba-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1500;
  width: 100%;
  height: 93vh;
  background: rgba( 163, 163, 163, 0.25 );
  backdrop-filter: blur( 4px );
  -webkit-backdrop-filter: blur( 4px );

  display: flex;
  align-items: center;
  justify-content: center;

  .tools-group {
    width: 100%;
  }
  .check-card {
    width: 100%;
    padding: 12px 20px;
    border-radius: 6px;
    background: #FFF;
    box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.16);

    .input-select {
      width: 100%;
      display: inline-flex;
      align-items: baseline;
      justify-content: space-between
    }
  }
  .check-title {
    margin: 30px 0 8px;
    padding: 15px;
    width: 100%;
    height: 55px;
    border-radius: 6px;
  }

  .ba-modal-content {
    width: 390px;
    height: 70%;
    overflow: hidden;
    border-radius: 8px;
    background: #FFF;

    padding: 12px;
    gap: 10px;

    .ba-modal--content {
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      padding: 0 .7rem 0 0;
    }
    .ba-modal--header {
      width: 100%;
      display: flex;
      padding: 5px;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      border-radius: 4px 10px;
      background: #E6EFFA;

      .header {
        color: #4D5D71;
      }
    }
  }
}

.tool_line {
  width: 94%;
  display: inline-flex;
  padding: 5px 0 2px 0;
  border-bottom: 0.5px solid #C0C0C0;

  input[type="checkbox"] {
    border: 2px solid #C0C0C0!important;
    box-sizing: border-box!important;
    border-radius: 1px!important;
  }

  span {
    font-family: 'Mulish';
    font-weight: 500;
    font-size: 15px;
    color: #434343;

    margin-left: .4rem;
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/team-access/ToolsModal.vue